import { formatPrice } from "helpers/common";
import { getRating } from "helpers/hotelHelper";
import useGetHotelAvailability from "hooks/hotel/useGetHotelAvailability";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import React, { useCallback, useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Link, useNavigate } from "react-router-dom";
const PromotionalCard = ({ offer }) => {
    const { t } = useTranslation();
    const rating = getRating(offer.stars);
    const { getHotelAvailability } = useGetHotelAvailability();
    const { setHotelSearchParams, setProviders, hotelSearchParams } =
        useHotelContext();
    const navigate = useNavigate();
    const [startSearch, setStartSearch] = useState(false);
    

    const fillState = async () => {
        setHotelSearchParams({
            destination: {
                id: offer.search_criteria.location_id,
                description: offer.location,
                descriptionEn: offer.location,
            },
            checkInDate: offer.search_criteria.checkin.split(" ")[0].trim(),
            checkOutDate: offer.search_criteria.checkout.split(" ")[0].trim(),
            rooms: offer.search_criteria.rooms.map((room) => ({
                adults: +room.number_of_adults,
                children: +room.number_of_children,
                childrenAges: Array.from(
                    { length: +room.number_of_children },

                    () => 3
                ),
            })),
        });
        setProviders(() => {
            return offer?.search_criteria.providers?.map((provider) => {
                return {
                    code: provider,
                    id: null,
                };
            });
        });
        setStartSearch(true);
    };

    const search = useCallback(async () => {
        navigate("/hotel-search");
        await getHotelAvailability();
        localStorage.setItem("hotelState", JSON.stringify(hotelSearchParams));
        setStartSearch(false);
    }, [navigate, getHotelAvailability, hotelSearchParams]);

    const handleClick = async () => {
        fillState();
    };

    useEffect(() => {
        if (startSearch) {
            search();
        }
    }, [startSearch, search]);

    return (
        <>
            <div
                className="theme_common_box_two img_hover"
                onClick={handleClick}
            >
                <div className="theme_two_box_img relative">
                    <Link to="#!">
                        <Image
                            loading="lazy"
                            className="h-[250px] w-full object-cover"
                            src={`https://staging-static-api.algebratec.com/${offer.image}`}
                            alt="img"
                        />
                    </Link>
                    <p className="z-20 relative truncate w-[80%]">
                        <i className="fas fa-map-marker-alt "></i>
                        {offer.location}
                    </p>
                    <div className="discount_tab z-20 ">
                        <span>-{offer.discount}%</span>
                    </div>
                    {/* Shadow from bottom to top */}
                    <div
                        className="absolute inset-0 w-full h-full pointer-events-none"
                        style={{
                            background:
                                "linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0))",
                        }}
                    ></div>
                </div>
                <div className="theme_two_box_content">
                    <h4>
                        <Link to="#!">{offer.name}</Link>
                    </h4>
                    <p className="text-main-color">
                        {offer.search_criteria.nights === 1
                            ? `0${offer.search_criteria.nights} ${t("night")}`
                            : offer.search_criteria.nights > 9
                            ? `${offer.search_criteria.nights} ${t("nights")}`
                            : `0${offer.search_criteria.nights} ${t("nights")}`}

                        {offer.search_criteria.rooms.length === 1
                            ? `, 0${offer.search_criteria.rooms.length} ${t(
                                  "room"
                              )}`
                            : `, 0${offer.search_criteria.rooms.length} ${t(
                                  "rooms"
                              )}`}
                    </p>
                    <div className="flex items-center justify-between">
                        <h3>{formatPrice(offer.price)} </h3>
                        <div className="flex gap-0.5 items-center">
                            <span className="rating">{rating}</span>
                            <i className="fas fa-star text-yellow-500"></i>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PromotionalCard;
